<template>
    <button @click="onClick" class="mobile-only-button" v-bind="$attrs">
        <slot></slot>
    </button>
</template>

<script setup>
import { onMounted, defineProps, reactive } from "vue";
const props = defineProps({
    code: {
        type: String,
        required: true,
    },
    teamId: {
        type: String,
    },
    isDisabled: {
        type: Boolean,
        default: false,
    },
    message: {
        type: String,
    },
});

const state = reactive({
    isApp: false,
});

const onClick = async () => {
    if (state.isApp) {
        if (props.isDisabled) {
            alert(
                `${props.message} is not available in app. Please purchase from www.clipboardnation.com.`
            );
            return true;
        }

        const data = await axios.get(`/payment-plan/${props.code}`);
        window.ReactNativeWebView.postMessage(
            JSON.stringify({
                action: "purchase",
                teamId: props.teamId,
                ...data.data,
            })
        );
        console.log({ data });
    }
};

onMounted(() => {
    if (window.ReactNativeWebView) {
        document.querySelectorAll(".web-purchase-button").forEach((element) => {
            element.style.display = "none";
        });
        document.querySelectorAll(".web-only-button").forEach((element) => {
            element.style.display = "none";
        });
        document.querySelectorAll(".mobile-only-button").forEach((element) => {
            element.style.display = "block";
        });
        state.isApp = true;
    }
});
</script>
